import React, { useMemo } from 'react';
import cx from 'clsx';

import { IconSendAsset, IconContract, IconCancel } from 'assets/swap';
import { IconApproval } from 'assets/overview';
import { HelperTooltip, LazyMedia } from '@/components';
import { CHAINS_DICT } from '@/utils/chain';

import style from './index.module.css';

interface Props {
  className?: string;
  chain?: string;
  url?: string;
  type?: string;
  size?: number;
  chainSize?: number;
  circle?: boolean;
  showChainTip?: boolean;
}

export const ProjectAvatar = (props: Props) => {
  const { className, url, size = 32, chain, type, circle, showChainTip } = props;

  const chainLogo = useMemo(() => chain && CHAINS_DICT[chain]?.logo, [chain]);

  const logoStyle = useMemo(
    () => ({
      width: size,
      height: size,
      borderRadius: circle ? size / 2 : 0,
      overflow: 'hidden',
    }),
    [size, circle],
  );

  const projectUrl = useMemo(() => {
    let src = '';

    if (url) {
      src = url;
    } else {
      switch (type) {
        case 'receive':
        case 'send':
          src = IconSendAsset;
          break;
        case 'cancel':
          src = IconCancel;
          break;
        case 'approve':
          src = IconApproval;
          break;
        default:
          src = IconContract;
      }
    }

    return src;
  }, [type, url]);

  return (
    <div className={cx(style.iconWithChain, className)}>
      <div style={logoStyle}>
        <LazyMedia className={style.icon} src={projectUrl} alt="" />
      </div>
      {chainLogo ? (
        chain && showChainTip ? (
          <HelperTooltip title={`On ${CHAINS_DICT[chain]?.name}`}>
            <LazyMedia className={style.chainLogo} src={chainLogo} alt="" />
          </HelperTooltip>
        ) : (
          <LazyMedia className={style.chainLogo} src={chainLogo} alt="" />
        )
      ) : null}
    </div>
  );
};
